<template>
    <div role="tabcard" class="tab-pane" id="selections">
        <selection-list :role="role" :user="user" :project="project"></selection-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        watch: {
        },

        computed: {
            
        },

        methods: {
        }
    }
</script>
